module.exports = __webpack_public_path__ + "static/img/gengxin.204d03e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/gengxin.png
// module id = 0Sfa
// module chunks = 24